import React, { Component } from 'react'
import BaseLayout from 'containers/BaseLayout'
import HeaderTitle from 'components/HeaderTitle'

import { gql } from 'apollo-boost'
import { Query } from 'react-apollo'

import {
  Columns, Column, Box, Button, Icon,
  Menu, MenuLabel, MenuList
} from 'bloomer'

import { Link, Redirect } from 'react-router-dom'
import { HouseContext } from 'contexts'
import { CURRENT_HOUSE_KEY } from '../../constants'

import CreateHouseModal from './modals/CreateHouseModal'

import HouseItem from './HouseItem'

const GET_HOUSES = gql`
  query {
    me {
      id,
      ownedHouses {
        id, name, description
      },
      associatedHouses {
        id, name, description, owner { firstName, lastName }
      }
    }
  }
`

export default class SwitchHousePage extends Component {

  state = {
    ready: false,
    isModalOpen: false
  }

  handleSelection = (update, houseId, evt) => {
    localStorage.setItem(CURRENT_HOUSE_KEY, houseId)
    update()
    this.setState(() => ({ready: true}))
  }

  handleModalOpen = () => {
    this.setState(() => ({
      isModalOpen: true
    }))
  }

  handleModalClose = () => {
    this.setState(() => ({
      isModalOpen: false
    }))
  }

  render() {
    const { ready, isModalOpen } = this.state

    if (ready) {
      return <Redirect to="/dashboard" />
    }

    return (
      <HouseContext.Consumer>
        {({houseId: currentHouseId, switchHouseHandler}) => (
          <Query query={GET_HOUSES}>
            {({data, loading, error, refetch}) => (
              <BaseLayout title={() => <HeaderTitle>Escolher casa</HeaderTitle>} loading={loading} error={error}>
                {(!loading && !error) && <Columns isCentered>
                  <Column isSize={{mobile: 12, desktop: '1/2'}}>
                    <Box>
                      <Button isPulled="right" onClick={this.handleModalOpen}>Criar nova casa</Button>
                      <Menu style={{marginBottom: '1rem'}}>
                        <MenuLabel>MINHAS CASAS</MenuLabel>
                        <MenuList>
                          {data.me.ownedHouses.map(house => (
                            <HouseItem
                              key={house.id}
                              house={house}
                              isCurrent={currentHouseId && currentHouseId === house.id}
                              isOwner={true}
                              onClick={this.handleSelection.bind(this, switchHouseHandler, house.id)}
                            />
                          ))}
                        </MenuList>
                        {data.me.associatedHouses.length > 0 &&
                          <React.Fragment>
                            <MenuLabel>OUTRAS CASAS</MenuLabel>
                            <MenuList>
                              {data.me.associatedHouses.map(house => (
                                <HouseItem
                                  key={house.id}
                                  house={house}
                                  isCurrent={currentHouseId && currentHouseId === house.id}
                                  onClick={this.handleSelection.bind(this, switchHouseHandler, house.id)}
                                />
                              ))}
                            </MenuList>
                          </React.Fragment>
                        }
                      </Menu>
                      <p><Icon icon="info-circle"/>Procurando como adicionar um familiar? Você pode fazer isso nas <Link to="/settings/houses">Configurações</Link>.</p>
                    </Box>
                  </Column>
                </Columns>}
                <CreateHouseModal isActive={isModalOpen} handleClose={this.handleModalClose} refetch={refetch} />
              </BaseLayout>
            )}
          </Query>
        )}
      </HouseContext.Consumer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SwitchHousePage/index.js